// packages/core/src/learning/LearningData.ts
// ─────────────────────────────────────────────────────────────────────────
// Assembles LEARNING_MODULES — the live curriculum consumed across the app.
//
// LEARNING_MODULES is the 12-module motivation-first Nisk Core Path PLUS the
// school-native Lens Pack modules (surface: 'school'). Both are in the array
// so lesson/flashcard/route resolution works app-wide; the Core Path map view
// filters to surface 'map'/undefined via getMapModules(), so Lens Packs never
// appear on the tier grid (Product Decision 1 — separate progress tracks).
//
// ./batches/ are PRESERVED on disk but no longer imported — legacy content is
// kept for reference only.
// ─────────────────────────────────────────────────────────────────────────

import type { LearningModule } from './LearningTypes';
import { CORE_PATH_MODULES } from './core-modules';
import { SCHOOL_MODULES } from './school-modules';

export const LEARNING_MODULES: LearningModule[] = [
	...CORE_PATH_MODULES,
	...SCHOOL_MODULES,
];
